

    import {Component, Prop, Vue} from 'vue-property-decorator';

    @Component({})
    export default class SplashMessage extends Vue {
        destroyed(){
            this.$store.commit('splashDisplayed', true);
        }
    }

